import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Instagram } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Giới Thiệu */}
          <div>
            <h3 className="text-white text-lg font-bold mb-4">Kính mắt Nhân Văn</h3>
            <p className="text-sm mb-4">
              Nguồn cung cấp kính mắt chất lượng đáng tin cậy. Chúng tôi cung cấp nhiều loại kính mát và kính cận cho mọi phong cách và nhu cầu.
            </p>
            <div className="flex gap-4">
              <a href="#" className="hover:text-primary-500 transition">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="hover:text-primary-500 transition">
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Liên Kết Nhanh */}
          <div>
            <h3 className="text-white text-lg font-bold mb-4">Liên Kết Nhanh</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="hover:text-primary-500 transition">
                  Trang Chủ
                </Link>
              </li>
              <li>
                <Link to="/products" className="hover:text-primary-500 transition">
                  Tất Cả Sản Phẩm
                </Link>
              </li>
              <li>
                <Link to="/products?category=sunglasses" className="hover:text-primary-500 transition">
                  Kính Mát
                </Link>
              </li>
              <li>
                <Link to="/products?category=nearsighted" className="hover:text-primary-500 transition">
                  Kính Cận
                </Link>
              </li>
            </ul>
          </div>

          {/* Dịch Vụ Khách Hàng */}
          <div>
            <h3 className="text-white text-lg font-bold mb-4">Dịch Vụ Khách Hàng</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/orders" className="hover:text-primary-500 transition">
                  Theo Dõi Đơn Hàng
                </Link>
              </li>
              <li>
                <a href="#" className="hover:text-primary-500 transition">
                  Chính Sách Đổi Trả
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-primary-500 transition">
                  Thông Tin Vận Chuyển
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-primary-500 transition">
                  Câu Hỏi Thường Gặp
                </a>
              </li>
            </ul>
          </div>

          {/* Liên Hệ */}
          <div>
            <h3 className="text-white text-lg font-bold mb-4">Liên Hệ</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <MapPin className="w-5 h-5 mt-0.5 flex-shrink-0" />
                <span>123 Đường Chính, Thành Phố, Việt Nam</span>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="w-5 h-5 flex-shrink-0" />
                <span>+84 123 456 789</span>
              </li>
              <li className="flex items-center gap-2">
                <Mail className="w-5 h-5 flex-shrink-0" />
                <span>contact@kinhnhanvan.com</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm">
          <p>&copy; {new Date().getFullYear()} Kính mắt Nhân Văn. Tất cả quyền được bảo lưu.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
